export const TYPE = {
    WEBSITE: 'website',
    ARTICLE: 'article'
};